<template>
  <p-create-configuration v-if="$hasPermission('administration')" />
  <p-not-found v-else />
</template>

<script>
import CreateConfiguration from '@/components/speech-to-text-configurations/CreateSttConfiguration.vue';
import NotFound from '@/components/NotFound.vue';

export default {
  components: {
    'p-create-configuration': CreateConfiguration,
    'p-not-found': NotFound
  }
};
</script>
